function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { keyframes } from '@emotion/core';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var linearIndeterminate = keyframes({
  '0%': {
    width: '0%',
    left: 0,
    right: 0
  },
  '50%': {
    width: '100%',
    left: 0,
    right: 0
  },
  '100%': {
    width: '0%',
    left: '100%',
    right: 0
  }
});
var circularIndeterminate = keyframes({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
var useStyles = _ref => {
  var {
    behavior,
    color
  } = _ref;
  var theme = useTheme();
  var indeterminate = behavior === 'indeterminate';
  var isHc = theme.mode === 'contrast';
  return React.useMemo(() => ({
    root: _extends({}, highContrastMediaQuery(theme), {
      display: 'block',
      color: color ? theme.color[color] : theme.palette.primary.default
    }, isHc && {
      color: theme.palette.foreground.default
    }),
    progressbar_circular: {
      display: 'block',
      height: theme.layout.size6,
      overflow: 'hidden',
      width: theme.layout.size6
    },
    progressbar_linear: {
      borderRadius: "calc(".concat(theme.borderRadius2, "/2)"),
      height: theme.layout.size1,
      overflow: 'hidden',
      position: 'relative',
      width: '100%'
    },
    circular: _extends({
      stroke: 'currentColor'
    }, indeterminate ? {
      animationDuration: '750ms',
      animationIterationCount: 'infinite',
      animationName: circularIndeterminate,
      animationTimingFunction: 'linear'
    } : {
      transform: 'rotate(-90deg)',
      '> circle': {
        transition: 'stroke-dashoffset 0.2s linear'
      }
    }),
    linear: _extends({
      backgroundColor: 'currentColor',
      borderRadius: "calc(".concat(theme.borderRadius2, "/2)"),
      bottom: 0,
      left: 0,
      position: 'absolute',
      top: 0,
      transformOrigin: 'left',
      transition: 'transform 0.2s linear',
      width: '100%'
    }, indeterminate && {
      animationDuration: '2s',
      animationIterationCount: 'infinite',
      animationName: linearIndeterminate,
      width: 'auto'
    }),
    linearBar: _extends({
      backgroundColor: theme.palette.stroke.default,
      borderRadius: "calc(".concat(theme.borderRadius2, "/2)"),
      bottom: 0,
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0
    }, isHc && {
      backgroundColor: 'trasparent',
      border: "1px solid ".concat(theme.palette.foreground.default)
    }),
    label: {
      color: theme.palette.foreground.default,
      display: 'inline-flex',
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size2,
      lineHeight: theme.typography.lineHeight2,
      marginTop: theme.orbitalTwo,
      transition: 'margin-left 0.2s linear'
    }
  }), [color, indeterminate, isHc, theme]);
};
export default useStyles;